import { fmtDate } from './plannerConstants';

// Clean, management-ready printable plan. Hidden on screen; only visible when
// printing. Parent toggles `visible` then calls window.print().
export function PlannerPrintView({ data, includeNotesNarrative }) {
  if (!data) return null;
  const { plan, groups, progress, members, org_name } = data;
  const memberName = (id) => (members.find((m) => m.id === id) || {}).name || 'Unassigned';

  return (
    <div className="planner-print-area" data-testid="planner-print-area">
      <style>{`
        .planner-print-area { display: none; }
        @media print {
          @page { margin: 14mm; size: A4; }
          body * { visibility: hidden !important; }
          .planner-print-area, .planner-print-area * { visibility: visible !important; }
          .planner-print-area { display: block !important; position: absolute; top: 0; left: 0; width: 100%; color: #111; font-family: Arial, Helvetica, sans-serif; }
          .pp-phase { break-inside: avoid; }
          table { border-collapse: collapse; width: 100%; }
          th, td { border: 1px solid #d1d5db; padding: 5px 7px; font-size: 11px; text-align: left; vertical-align: top; }
          th { background: #1f2937; color: #fff; }
          .pp-blocked td { background: #fee2e2; }
          .pp-overdue td { background: #fff7ed; }
        }
      `}</style>

      <div style={{ marginBottom: 14 }}>
        <h1 style={{ fontSize: 22, margin: 0 }}>{org_name}</h1>
        <div style={{ fontSize: 13, color: '#374151' }}>{plan.name}</div>
      </div>

      <table style={{ marginBottom: 16 }}>
        <tbody>
          <tr>
            <th>Plan Start</th><td>{fmtDate(plan.plan_start_date)}</td>
            <th>Target Go-Live</th><td>{fmtDate(plan.target_go_live_date)}</td>
            <th>Overall Progress</th><td><strong>{progress.overall_pct}%</strong></td>
          </tr>
          <tr>
            <th>Completed</th><td>{progress.completed}</td>
            <th>In Progress</th><td>{progress.in_progress}</td>
            <th>Pending</th><td>{progress.pending}</td>
          </tr>
          <tr>
            <th>Blocked</th><td>{progress.blocked}</td>
            <th>Overdue</th><td>{progress.overdue}</td>
            <th>Status</th><td>{plan.status}</td>
          </tr>
        </tbody>
      </table>

      {includeNotesNarrative && plan.management_update && (
        <div style={{ marginBottom: 16 }}>
          <h3 style={{ fontSize: 14, marginBottom: 4 }}>Management Summary</h3>
          <p style={{ fontSize: 12, whiteSpace: 'pre-wrap' }}>{plan.management_update}</p>
        </div>
      )}

      {groups.map((g) => (
        <div key={g.phase} className="pp-phase" style={{ marginBottom: 14 }}>
          <h3 style={{ fontSize: 14, margin: '0 0 6px', borderBottom: '2px solid #1f2937', paddingBottom: 3 }}>{g.phase}</h3>
          <table>
            <thead>
              <tr>
                <th style={{ width: '28%' }}>Task</th><th>Owner</th><th>Priority</th>
                <th>Status</th><th>Start</th><th>End</th><th>Progress</th>
              </tr>
            </thead>
            <tbody>
              {g.tasks.map((t) => (
                <tr key={t.id} className={t.status === 'Blocked' ? 'pp-blocked' : t.overdue ? 'pp-overdue' : ''}>
                  <td>{t.title}{t.is_custom ? ' (custom)' : ''}{t.status === 'Blocked' && t.blocked_reason ? ` — Blocked: ${t.blocked_reason}` : ''}</td>
                  <td>{memberName(t.assigned_user_id)}</td>
                  <td>{t.priority}</td>
                  <td>{t.status}{t.overdue ? ' (overdue)' : ''}</td>
                  <td>{fmtDate(t.planned_start_date)}</td>
                  <td>{fmtDate(t.planned_end_date)}</td>
                  <td>{t.volume_info?.enabled ? (t.volume_info.display || '—') : '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

export default PlannerPrintView;
